import { render, staticRenderFns } from "./hospitalAdd.vue?vue&type=template&id=18638928&scoped=true&"
import script from "./hospitalAdd.vue?vue&type=script&lang=js&"
export * from "./hospitalAdd.vue?vue&type=script&lang=js&"
import style0 from "./hospitalAdd.vue?vue&type=style&index=0&id=18638928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18638928",
  null
  
)

export default component.exports